import React from 'react'
import { cx } from '@/lib/utils'
import {
  Bot, Code, Gauge, KeyRound, ShieldCheck, UserCheck, Workflow, type LucideIcon,
} from 'lucide-react'
import styles from './IconBox.module.scss'

export type IconName =
  | 'bot' | 'code' | 'gauge' | 'key' | 'shield' | 'user-check' | 'workflow'

type Size = 'sm' | 'md'

interface IconBoxProps {
  icon: IconName
  size?: Size
}

const iconComponents: Record<IconName, LucideIcon> = {
  bot: Bot, code: Code, gauge: Gauge, key: KeyRound, shield: ShieldCheck,
  'user-check': UserCheck, workflow: Workflow,
}

const sizeConfig: Record<Size, { cls: string; iconSize: number }> = {
  sm: { cls: styles.sizeSm, iconSize: 18 },
  md: { cls: styles.sizeMd, iconSize: 22 },
}

export const IconBox: React.FC<IconBoxProps> = ({ icon, size = 'md' }) => {
  const Icon = iconComponents[icon]
  const config = sizeConfig[size]
  return (
    <div className={cx(styles.box, config.cls)}>
      <Icon size={config.iconSize} strokeWidth={1.75} />
    </div>
  )
}
